import { Pipe, PipeTransform } from '@angular/core';

import { LocaleService } from '../components';

@Pipe({
  name: 'Translate',
})
export class TranslatePipe implements PipeTransform {
  constructor(private locale: LocaleService) {}

  transform(value: any): any {
    const attrs = value.split('.');
    let aux: object;
    try {
      aux = this.locale.getTranslations();
      attrs.forEach((item) => {
        aux = aux[item];
      });
    } catch (e) {
      console.warn(`Missing translation for key "${value}" (locale: ${this.locale.current})`);
      console.error(e);

      return value;
    }

    return aux;
  }
}
